import { serviceMaker, methods, api } from "@/http/index.js";

export const getRegions = () => serviceMaker(`/regions`, methods.GET, api.NGB);

export const getRegionsTemplate = () =>
  serviceMaker(`/regions/template`, methods.GET, api.NGB);

export const getPriceRegions = (id) =>
  serviceMaker(`/regions/${id}`, methods.GET, api.NGB);

export const createpriceRegion = (data) =>
  serviceMaker(`/regions`, methods.POST, api.NGB, data);

export const getStates = (id, data) =>
  serviceMaker(`/regions/getstates/${id}`, methods.POST, api.NGB, data);

export const editpriceRegion = (id, data) =>
  serviceMaker(`/regions/${id}`, methods.PUT, api.NGB, data);

export const deletepriceRegion = (id) =>
  serviceMaker(`/regions/${id}`, methods.DELETE, api.NGB);
